export default __webpack_public_path__ + "c9eb6e2cf799c8065d6dbb0db8d26674.svg";